/**
* map JS
* -----------------------------------------------------------------------------
*
* All the JS for the map component.
*/

( function( app ) {
  const COMPONENT = {

    className: 'map',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'map', COMPONENT );
} )( app );
